// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"96":"955cd318bd2efbea3d71","888":"1b847303132b3cf95af8","964":"5efd5ac6468bff9f76e0"}[chunkId] + ".css";
};